const getFormFieldState = ({ disabled, error })=>{
    if (disabled) return 'disabled';
    if (error) return 'error';
    return 'normal';
};
export { getFormFieldState };
